<template>
  <div class="content">
    <div class="container">
      <div :class="{ active: curRoute === 'home' }" @click="$routeChange('home')">
        <div class="text">{{ lang.homePage }}</div>
      </div>
      <div @click="showChildMenu('about')" :class="{ openchild: showAboutChild }">
        <div class="text">
          <label>{{ lang.aboutUs }}</label>
          <span></span>
        </div>
        <div class="childmenu" v-show="showAboutChild">
          <div class="text" :class="{ active: curRoute === 'about' }" @click="$routeChange('about')">
            {{ lang.aboutUs_1 }}
          </div>
          <div class="text" :class="{ active: curRoute === 'news' }" @click="$routeChange('news')">
            {{ lang.aboutUs_2 }}
          </div>
        </div>
      </div>
      <div @click="showChildMenu('join')" :class="{ openchild: showJoinChild }">
        <div class="text">
          <label>{{ lang.joinUs }}</label>
          <span></span>
        </div>
        <div class="childmenu" v-show="showJoinChild">
          <a class="text" v-bind:href="joinUsSocialLink" target="_blank">
            {{ lang.joinUs_1 }}
          </a>
          <a class="text" v-bind:href="joinUsCampusLink" target="_blank">
            {{ lang.joinUs_2 }}
          </a>
        </div>
      </div>
      <div :class="{ active: curRoute === 'connection' }" @click="$routeChange('connection')">
        <div class="text">{{ lang.contactUs }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import mapStore from "@/mixins/mapStore";
export default {
  mixins: [
    mapStore("", {
      getters: ["lang"],
    }),
  ],
  data() {
    return {
      visible: false,
      showAboutChild: false,
      showJoinChild: false,
      joinUsCampusLink: process.env.VUE_APP_MOKA_CAMPUS_LINK || '',
      joinUsSocialLink: process.env.VUE_APP_MOKA_SOCIAL_LINK || ''
    };
  },
  computed: {
    curRoute() {
      return this.$route.path.slice(1);
    },
  },
  methods: {
    showChildMenu(menu) {
      if (menu === 'join') {
        this.showAboutChild = false
        this.showJoinChild = !this.showJoinChild
      } else if (menu === 'about') {
        this.showJoinChild = false
        this.showAboutChild = !this.showAboutChild
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding-top: 52px;
}

.container {
  height: 100vh;
  padding-top: 52px;
  padding: 0 20px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);

  >div {
    border-bottom: 1px solid #d8dcdf;

    .text {
      color: #3d434d;
      display: flex;
      height: 66px;
      align-items: center;
      justify-content: center;
      text-align: center;

      *> {
        margin: 0;
      }

      span {
        display: block;
        width: 7px;
        height: 7px;
        border: 1px solid #242a32;
        border-left: none;
        border-bottom: none;
        transform: rotate(45deg) translateY(3px);
        margin-left: 12px;
      }
    }
  }
}

.active {
  color: #2284f6;
}


.childmenu {
  position: relative;

  .childmenu {

    div,
    a {
      height: 66px;
    }
  }
}

.openchild {
  .text {
    span {
      transform: rotate(135deg) !important;
    }
  }
}
</style>